import { mpWxAppLifeCircle, mpWxPageLifeCircle } from '@/constants/lifeCircleConst.ts';
import type { ISetupConf } from '@/types/setup.ts';
import { mpWxProxy } from '@/core/eventProxy';

function uniPageLifeRefactor(uni) {
  const mixinObj: any = {};
  mpWxPageLifeCircle.forEach((life) => {
    const lifeFn = mpWxProxy.Page[life];
    mixinObj[life] = function (opts) {
      console.group(`uni life: ${life}`);
      console.log('life: ', life);
      console.log('this: ', this, this?.mpType || 'no mpType', this?.$mpType || 'no $mpType');
      console.log('opts: ', opts);
      const mpType = this.mpType || this.$mpType;
      if (lifeFn && mpType === 'page') {
        lifeFn.call(this.$scope, opts);
      }
      console.groupEnd();
    };
  });
  uni.mixin(mixinObj);
}
export class MpWxSetup {
  private config: ISetupConf | null = null;
  public constructor(config?: ISetupConf) {
    console.log('mpWx setup: ', config);
    this.config = config || null;
    this.setAppTrack();
    if (this.config?.uni) {
      this.setUniPageTrack();
    } else {
      this.setPageTrack();
      this.setCompTypePageTrack();
    }
    this.setComponentTrack();
  }
  private setUniPageTrack() {
    if (this.config?.uni) {
      uniPageLifeRefactor(this.config.uni);
    }
  }
  private setPageTrack() {
    console.log('in Page setup');
    const originalPage = Page;
    if (!this.config?.uni) {
      Page = function (...optsObj) {
        console.log('Page: ', optsObj);
        const _lifeCircle = {};
        const opts = optsObj[0];
        mpWxPageLifeCircle.forEach((life) => {
          const lifeFn = mpWxProxy.Page[life];
          _lifeCircle[life] = opts[life];
          opts[life] = function (_opts) {
            console.group(`mp-wx life: ${life}`);
            console.log('opts: ', _opts);
            console.log('this: ', this);
            _lifeCircle?.[life]?.call(this, _opts);
            if (lifeFn) {
              lifeFn.call(this, _opts);
            }
            console.groupEnd();
          };
        });
        return originalPage(...optsObj);
      };
    }
  }
  private setCompTypePageTrack() {
    const originalComp = Component;
    // const _lifeCircle = {};
    if (!this.config?.uni) {
      Component = function (...opts) {
        const _lifeCircle = {};
        if (!opts[0].methods) {
          opts[0].methods = {};
        }
        mpWxPageLifeCircle.forEach((life) => {
          const lifeFn = mpWxProxy.Page[life];
          _lifeCircle[life] = opts[0]?.methods?.[life];
          opts[0].methods[life] = function (_opts) {
            _lifeCircle?.[life]?.call(this, _opts);
            if (lifeFn) {
              lifeFn.call(this, _opts);
            }
          };
        });
        return originalComp(...opts);
      };
    }
  }
  private setComponentTrack() {
    // todo: 组件上报
  }
  private setAppTrack() {
    console.log('in App setup');
    const originalApp = App;
    App = function (...optsObj) {
      const _lifeCircle = {};
      const opts = optsObj[0];
      mpWxAppLifeCircle.forEach((life) => {
        const lifeFn = mpWxProxy.App[life];
        _lifeCircle[life] = opts[life];
        opts[life] = function (_opts) {
          _lifeCircle?.[life]?.call(this, _opts);
          if (lifeFn) {
            lifeFn.call(this, _opts);
          }
        };
      });
      return originalApp(...optsObj);
    };
  }
}

export default MpWxSetup;
